/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Cancelfailed1Inputs */

const zh_subscription_cancelfailed1 = /** @type {(inputs: Subscription_Cancelfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尝试取消订阅失败`)
};

const en_subscription_cancelfailed1 = /** @type {(inputs: Subscription_Cancelfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to cancel subscription`)
};

const es_subscription_cancelfailed1 = /** @type {(inputs: Subscription_Cancelfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cancelar la suscripción`)
};

/**
* | output |
* | --- |
* | "Failed to cancel subscription" |
*
* @param {Subscription_Cancelfailed1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_cancelfailed1 = /** @type {((inputs?: Subscription_Cancelfailed1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Cancelfailed1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_cancelfailed1(inputs)
	if (locale === "en") return en_subscription_cancelfailed1(inputs)
	return es_subscription_cancelfailed1(inputs)
});
export { subscription_cancelfailed1 as "subscription_cancelFailed" }